import styled from 'styled-components';
import { colors } from '../../../../variables/colors.js';
import { deviceWidths } from '../../../../variables/widths.js';

var HotelHitContentBodyContainer = styled.div.withConfig({
  displayName: "hotelHitContentBody__HotelHitContentBodyContainer",
  componentId: "sc-3sbk25-0"
})(["display:flex;flex-grow:1;flex-direction:column;justify-content:space-between;padding:0 8px 28px 8px;width:100%;position:relative;@media (min-width:", "){padding:0 16px 16px 16px;}"], deviceWidths.tablet);
var HotelHitContentBodyContent = styled.div.withConfig({
  displayName: "hotelHitContentBody__HotelHitContentBodyContent",
  componentId: "sc-3sbk25-1"
})(["align-items:flex-start;display:flex;justify-content:flex-end;@media (min-width:", "){justify-content:space-between;}"], deviceWidths.tablet);
var UspList = styled.ul.withConfig({
  displayName: "hotelHitContentBody__UspList",
  componentId: "sc-3sbk25-2"
})(["color:", ";display:none;padding:0 0 0 8px;@media (min-width:", "){display:block;}"], colors.darkGray, deviceWidths.tablet);
var UspListItem = styled.li.withConfig({
  displayName: "hotelHitContentBody__UspListItem",
  componentId: "sc-3sbk25-3"
})(["list-style-type:disc;margin:0 0 4px 12px;"]);
var GuestRatingContainer = styled.div.withConfig({
  displayName: "hotelHitContentBody__GuestRatingContainer",
  componentId: "sc-3sbk25-4"
})(["text-align:right;@media (min-width:", "){align-items:flex-end;display:flex;flex-direction:column;flex-shrink:0;}.sg-hotel-hit__trip-advisor-rating{bottom:8px;left:8px;position:absolute;@media (min-width:", "){align-items:flex-end;margin-top:8px;position:static;}}"], deviceWidths.tablet, deviceWidths.tablet);

export { GuestRatingContainer, HotelHitContentBodyContainer, HotelHitContentBodyContent, UspList, UspListItem };
//# sourceMappingURL=hotelHitContentBody.js.map
